import classNames from 'classnames'

import PriceUnavailable from '@/components/Feed/PriceUnavailable/PriceUnavailable'
import UpdatedAtTooltip from '@/components/Feed/UpdatedAtTooltip/UpdatedAtTooltip'
import type { SegmentOfferPrice } from '@/types'
import { formatPriceWithVat } from '@/utils/price/vat'

import { formatSegmentPriceDiff } from './segmentPriceFormat'
import cn from './SegmentPriceValue.module.scss'

type SegmentPriceValueProps = {
  segmentPrice: SegmentOfferPrice | undefined
  contextPrice: number | null | undefined
  suffix?: string
}

function SegmentPriceValue({
  segmentPrice,
  contextPrice,
  suffix = '',
}: SegmentPriceValueProps) {
  const sellingPrice = segmentPrice?.sellingPrice
  if (sellingPrice === undefined) {
    return (
      <PriceUnavailable
        price={{ unavailableReason: segmentPrice?.unavailableReason }}
      />
    )
  }
  const diff = formatSegmentPriceDiff(sellingPrice, contextPrice)

  return (
    <UpdatedAtTooltip updatedAt={segmentPrice?.priceUpdatedAt} kind="price">
      <span className={cn.value}>
        <span className={cn.price}>
          {formatPriceWithVat(sellingPrice)}
          {suffix}
        </span>
        {diff && (
          <span
            className={classNames(
              cn.diff,
              diff.direction === 'cheaper' && cn.cheaper,
              diff.direction === 'pricier' && cn.pricier
            )}
          >
            {diff.text}
          </span>
        )}
      </span>
    </UpdatedAtTooltip>
  )
}

export default SegmentPriceValue
